import { render, staticRenderFns } from "./option-group.vue?vue&type=template&id=0468de7a&"
import script from "./option-group.vue?vue&type=script&lang=js&"
export * from "./option-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0468de7a')) {
      api.createRecord('0468de7a', component.options)
    } else {
      api.reload('0468de7a', component.options)
    }
    module.hot.accept("./option-group.vue?vue&type=template&id=0468de7a&", function () {
      api.rerender('0468de7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/option-group.vue"
export default component.exports